var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.78 131.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #324578;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.78,
    width: 99,
    height: 28.31,
    rx: 9.44,
    ry: 9.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 51.63,
    width: 162.78,
    height: 28.31,
    rx: 9.44,
    ry: 9.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 103.26,
    width: 162.78,
    height: 28.31,
    rx: 9.44,
    ry: 9.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButton);
export default __webpack_public_path__ + "static/media/MenuButton.0db0a522a3149919d3d710d3d54c4679.svg";
export { ForwardRef as ReactComponent };